document.addEventListener('DOMContentLoaded', () => {

  const footer = document.querySelector('.footer-premium');

  if (!footer) return;

  /*==============================
    Feature Card Hover
  ==============================*/

  const cards = footer.querySelectorAll('.footer-feature');

  cards.forEach((card) => {

    card.addEventListener('mouseenter', () => {
      card.style.transform = 'translateY(-8px)';
    });

    card.addEventListener('mouseleave', () => {
      card.style.transform = 'translateY(0)';
    });

  });

  /*==============================
    Social Hover
  ==============================*/

  const socials = footer.querySelectorAll('.footer-social a');

  socials.forEach((item) => {

    item.addEventListener('mouseenter', () => {
      item.style.transform = 'translateY(-4px)';
    });

    item.addEventListener('mouseleave', () => {
      item.style.transform = '';
    });

  });

  /*==============================
    Payment Icons Hover
  ==============================*/

  const payments = footer.querySelectorAll('.footer-payments svg');

  payments.forEach((icon) => {

    icon.addEventListener('mouseenter', () => {
      icon.style.transform = 'translateY(-3px)';
    });

    icon.addEventListener('mouseleave', () => {
      icon.style.transform = '';
    });

  });

});